module.exports = __webpack_public_path__ + "src/assets/animations/worker.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/worker.png
// module id = ./src/assets/animations/worker.png
// module chunks = 0